// extracted by mini-css-extract-plugin
module.exports = {"headImage":"_6070","list":"_19387"};